import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { Tabs, Tab, Button } from "react-bootstrap";
import TestCaseEditor from "./TestCaseEditor";
import { compilerAxios } from "../../axios.config";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";

interface ICCStep3Props {
	data: ICodingData;
	prev: (data: ICodingData) => unknown;
	submit: (data: ICodingData) => unknown;
	outOfScore: number;
}

type dataLanguage = [
	{
		language: language_options_l;
	},
	Array<{
		scannerInput?: string;
		code?: string;
		name: string;
		output: string;
	}>
];
type dataLanguage_pvt = [
	{
		language: language_options_l;
	},
	Array<{
		scannerInput?: string;
		code?: string;
		name: string;
		output: string;
		marks: number;
	}>
];
export default function CCStep3(props: ICCStep3Props) {
	const animatecomponent = makeAnimated();
	const { data, prev, submit, outOfScore } = props;
	const [checkedLangs, setCheckedLangs] = useState<Array<language_options>>(
		[]
	);
	const [languageTab, setLanguageTab] = useState<language_options>("C");
	const [cloneFromLang, setCloneFromLang] = useState({
		value: "",
		label: "",
	});
	const [cloneToLang, setCloneToLang] = useState<
		ReadonlyArray<{
			value: language_options;
			label: language_options;
		}>
	>([]);

	const [loading, isLoading] = useState<boolean>(false);
	const [isSubmit, setIsSubmit] = useState<boolean>(true);
	const [testCaseType, setTestCaseType] = useState<"public" | "private">(
		"public"
	);
	const [data_c, setData_c] = useState<dataLanguage>([
		{
			language: "c",
		},
		[],
	]);
	const [data_cpp, setData_cpp] = useState<dataLanguage>([
		{
			language: "c++",
		},
		[],
	]);
	let [data_java, setData_java] = useState<dataLanguage>([
		{
			language: "java",
		},
		[],
	]);
	const [data_python, setData_python] = useState<dataLanguage>([
		{
			language: "python3",
		},
		[],
	]);
	const [data_c_pvt, setData_c_pvt] = useState<dataLanguage_pvt>([
		{
			language: "c",
		},
		[],
	]);
	const [data_cpp_pvt, setData_cpp_pvt] = useState<dataLanguage_pvt>([
		{
			language: "c++",
		},
		[],
	]);
	let [data_java_pvt, setData_java_pvt] = useState<dataLanguage_pvt>([
		{
			language: "java",
		},
		[],
	]);
	const [data_python_pvt, setData_python_pvt] = useState<dataLanguage_pvt>([
		{
			language: "python3",
		},
		[],
	]);

	function handleTestCaseTypeChange(
		event: React.MouseEvent<HTMLElement, MouseEvent>,
		newType: string
	) {
		if (newType !== "public" && newType !== "private") {
			return;
		}
		if (newType !== null) {
			setTestCaseType(newType);
		}
	}

	useEffect(() => {
		const compareArrays = (
			array1: Array<string>,
			array2: Array<string>
		): boolean => {
			return (
				array1.length === array2.length &&
				array1.every((el) => array2.includes(el))
			);
		};

		let val = compareArrays(checkedLangs, data.languages);
		setIsSubmit(!val);
	}, [checkedLangs, data.languages]);

	/**
	 * Loads test cases if it's already stored in data object
	 */
	useEffect(() => {
		if (data.languages.length > 0) {
			setLanguageTab(data.languages[0]);
		}
		data.languages.forEach((lang) => {
			// if (testCaseType === "private") {
			let pvt_testcase: dataLanguage_pvt = data.privateTestcases.filter(
				(val) => val[0].language === getTestCaseLang(lang)
			)[0];
			if (!pvt_testcase) return;
			if (lang === "C") setData_c_pvt(pvt_testcase);
			else if (lang === "C++") setData_cpp_pvt(pvt_testcase);
			else if (lang === "Java") setData_java_pvt(pvt_testcase);
			else setData_python_pvt(pvt_testcase);
			// } else {
			let testcase: dataLanguage = data.testcases.filter(
				(val) => val[0].language === getTestCaseLang(lang)
			)[0];
			if (!testcase) return;
			if (lang === "C") setData_c(testcase);
			else if (lang === "C++") setData_cpp(testcase);
			else if (lang === "Java") setData_java(testcase);
			else setData_python(testcase);
			// }
		});
	}, [data.languages, data.privateTestcases, data.testcases]);

	function getTestCaseLang(val: language_options): language_options_l {
		switch (val) {
			case "C":
				return "c";
			case "C++":
				return "c++";

			case "Java":
				return "java";

			default:
				return "python3";
		}
	}

	function submitHandler() {
		let testcases: Array<
			[
				{ language: language_options_l },
				Array<{
					code?: string;
					name: string;
					output: string;
					scannerInput?: string;
				}>
			]
		> = [data_c, data_cpp, data_python, data_java];
		let privateTestcases: Array<
			[
				{ language: language_options_l },
				Array<{
					scannerInput?: string;
					code?: string;
					name: string;
					output: string;
					marks: number;
				}>
			]
		> = [data_c_pvt, data_cpp_pvt, data_python_pvt, data_java_pvt];
		// console.log(privateTestcases);
		let chechItOut = true;
		privateTestcases.map((each) => {
			let test_cases_total_marks_sum = 0;
			each[1].map((data) => {
				test_cases_total_marks_sum += data.marks;
			});
			if (
				test_cases_total_marks_sum !== outOfScore &&
				each[1].length !== 0
			) {
				chechItOut = false;
				// console.log(each[0].language);
				//             console.log(outOfScore)
				//             console.log(test_cases_total_marks_sum)
				//             console.log(each[1])
			}
			return;
		});
		if (data.hasPrivateTestCases) {
			// when private test cases is allowed only
			if (chechItOut) {
				console.log("yes");
				submit({ ...data, testcases, privateTestcases });
			} else {
				alert(
					"Make Sure Sum of Marks of TestCases of Each Language Should equal to Out Of Score Given."
				);
			}
			return;
		}

		submit({ ...data, testcases, privateTestcases });
	}

	function getEditorVariable<T>(lang: language_options): T {
		if (testCaseType === "private") {
			switch (lang) {
				case "C++":
					return JSON.parse(JSON.stringify(data_cpp_pvt));

				case "C":
					return JSON.parse(JSON.stringify(data_c_pvt));

				case "Java":
					return JSON.parse(JSON.stringify(data_java_pvt));

				default:
					return JSON.parse(JSON.stringify(data_python_pvt));
			}
		} else {
			switch (lang) {
				case "C++":
					return JSON.parse(JSON.stringify(data_cpp));

				case "C":
					return JSON.parse(JSON.stringify(data_c));

				case "Java":
					return JSON.parse(JSON.stringify(data_java));

				default:
					return JSON.parse(JSON.stringify(data_python));
			}
		}
	}

	function getEditorLang(lang: string): "cpp" | "c" | "java" | "python" {
		switch (lang) {
			case "C++":
				return "cpp";

			case "C":
				return "c";

			case "Java":
				return "java";

			case "Python3":
				return "python";
		}

		return "cpp";
	}

	function onEditorChange(
		lang: language_options_l,
		index: number,
		value: string,
		type: "code" | "output" | "scannerInput" | "marks"
	): void {
		function updatePvtState(prev: dataLanguage_pvt): dataLanguage_pvt {
			if (type === "marks") {
				prev[1][index][type] = parseInt(value);
			} else {
				prev[1][index][type] = value;
			}

			return JSON.parse(JSON.stringify([...prev]));
		}
		// console.log(data_c_pvt)

		if (testCaseType === "private") {
			if (lang === "c") {
				setData_c_pvt(updatePvtState);
			} else if (lang === "c++") {
				setData_cpp_pvt(updatePvtState);
			} else if (lang === "java") {
				setData_java_pvt(updatePvtState);
			} else {
				setData_python_pvt(updatePvtState);
			}
		} else {
			if (type === "marks") return;
			if (lang === "c") {
				setData_c((prev) => {
					prev[1][index][type] = value;

					return JSON.parse(JSON.stringify([...prev]));
				});
			} else if (lang === "c++") {
				setData_cpp((prev) => {
					prev[1][index][type] = value;

					return JSON.parse(JSON.stringify([...prev]));
				});
			} else if (lang === "java") {
				setData_java((prev) => {
					prev[1][index][type] = value;

					return JSON.parse(JSON.stringify([...prev]));
				});
			} else {
				setData_python((prev) => {
					prev[1][index][type] = value;

					return JSON.parse(JSON.stringify([...prev]));
				});
			}
		}
	}

	function testCasePop(lang: language_options_l) {
		if (testCaseType === "private") {
			if (lang === "c") setData_c_pvt(popFromState);
			else if (lang === "c++") setData_cpp_pvt(popFromState);
			else if (lang === "java") setData_java_pvt(popFromState);
			else setData_python_pvt(popFromState);
		} else {
			if (lang === "c") setData_c(popFromState);
			else if (lang === "c++") setData_cpp(popFromState);
			else if (lang === "java") setData_java(popFromState);
			else setData_python(popFromState);
		}
	}
	function popFromState<DataType>(prev: DataType): DataType {
		let temp_arr = JSON.parse(JSON.stringify(prev));
		temp_arr[1].pop();

		return temp_arr;
	}
	function addToState<DataType>(prev: DataType, code: string): DataType {
		let temp_arr = JSON.parse(JSON.stringify(prev));
		let len = temp_arr[1].length;
		if (testCaseType === "private") {
			temp_arr[1].push({
				name: `Test Case ${len + 1}`,
				code: `${code}`,
				output: ``,
				marks: 1,
			});
		} else {
			temp_arr[1].push({
				name: `Test Case ${len + 1}`,
				code: `${code}`,
				output: ``,
			});
		}
		return temp_arr;
	}
	function addTestCase(lang: language_options_l): void {
		if (testCaseType === "private") {
			if (lang === "c") {
				setData_c_pvt((prev) =>
					addToState(
						prev,
						"int main(){\n    // write your code here\n}"
					)
				);
			} else if (lang === "c++") {
				setData_cpp_pvt((prev) =>
					addToState(
						prev,
						`int main(){\n    // write your code here\n}`
					)
				);
			} else if (lang === "java") {
				setData_java_pvt((prev) =>
					addToState(
						prev,
						`public class Main {\n\tpublic static void main(String[] args){\n        // write your code here\n\t}\n}`
					)
				);
			} else {
				setData_python_pvt((prev) =>
					addToState(
						prev,
						`if __name__=='__main__':\n    ## write your code here`
					)
				);
			}
		} else {
			if (lang === "c") {
				setData_c((prev) =>
					addToState(
						prev,
						"int main(){\n    // write your code here\n}"
					)
				);
			} else if (lang === "c++") {
				setData_cpp((prev) =>
					addToState(
						prev,
						`int main(){\n    // write your code here\n}`
					)
				);
			} else if (lang === "java") {
				setData_java((prev) =>
					addToState(
						prev,
						`public class Main {\n\tpublic static void main(String[] args){\n        // write your code here\n\t}\n}`
					)
				);
			} else {
				setData_python((prev) =>
					addToState(
						prev,
						`if __name__=='__main__':\n    ## write your code here`
					)
				);
			}
		}
	}

	function handleChecks() {
		// let langId: number;
		if (languageTab === "C") {
			if (data.hasPrivateTestCases && data_c_pvt[1].length === 0) {
				alert("Please add private test cases first");
				return;
			}
			runAllTestCases(
				data_c,
				languageTab,
				{
					language: "c",
				},
				data_c_pvt
			);
		} else if (languageTab === "Java") {
			if (data.hasPrivateTestCases && data_java_pvt[1].length === 0) {
				alert("Please add private test cases first");
				return;
			}
			runAllTestCases(
				data_java,
				languageTab,
				{
					language: "java",
				},
				data_java_pvt
			);
		} else if (languageTab === "Python3") {
			if (data.hasPrivateTestCases && data_python_pvt[1].length === 0) {
				alert("Please add private test cases first");
				return;
			}
			runAllTestCases(
				data_python,
				languageTab,
				{
					language: "python",
				},
				data_python_pvt
			);
		} else {
			if (data.hasPrivateTestCases && data_cpp_pvt[1].length === 0) {
				alert("Please add private test cases first");
				return;
			}
			runAllTestCases(
				data_cpp,
				languageTab,
				{
					language: "cpp",
				},
				data_cpp_pvt
			);
		}
	}

	function CheckTestCase(output: string, expected_output: string): boolean {
		let foo = output.replace(/\r?\n|\r/g, "");
		let doo = String(expected_output).replace(/\r?\n|\r/g, "");
		foo = foo.replace(/ /g, "");

		let passed = false;

		if (foo === doo) {
			passed = true;
			return passed;
		} else {
			let newstring1 = "";
			doo = doo.replace(/ /g, "");

			for (var i = 0; i < doo.length; i++) {
				if (doo[i] === undefined) {
					continue;
				}
				if (doo[i] === " ") {
					continue;
				} else {
					newstring1 += doo[i];
				}
			}
			if (newstring1 === foo) {
				passed = true;
			}

			return passed;
		}
	}

	async function runAllTestCases(
		testCases: dataLanguage,
		lang: language_options,
		compiler_data: {
			language: "c" | "cpp" | "java" | "python";
		},
		pvt_testcase: dataLanguage_pvt
	) {
		let solutions = data.solutions.filter(
			(val) => val.language === lang
		)[0];
		if (!solutions) {
			alert("No Solutions found for Language: " + lang);
			return;
		}

		isLoading(true);
		let total_checks =
			solutions.codeSolutions.length * testCases[1].length +
			solutions.codeSolutions.length * pvt_testcase[1].length;
		let compilerCount = 0;

		for (let i = 0; i < solutions.codeSolutions.length; i++) {
			let sol = solutions.codeSolutions[i];

			if (lang === "Python3") {
				sol = sol + "\n";
			}

			for (let j = 0; j < testCases[1].length; j++) {
				let testcase = testCases[1][j];
				let encoded_code = "";
				if (data.hasScannerInputs) {
					encoded_code = Buffer.from(sol, "utf8").toString("base64");
				} else {
					encoded_code = Buffer.from(
						sol + testcase.code,
						"utf8"
					).toString("base64");
				}
				let breakLoop = false;
				await compilerAxios
					.post("/compile", {
						...compiler_data,
						code: encoded_code,
						input: data.hasScannerInputs
							? testcase.scannerInput?.replace("\r\n", "\n")
							: "",
						arguments: [],
					})
					// eslint-disable-next-line no-loop-func
					.then(({ data: result_data }) => {
						if (result_data.output !== null) {
							const code_output = Buffer.from(
								result_data.output,
								"base64"
							).toString("utf8");
							if (CheckTestCase(code_output, testcase.output)) {
								++compilerCount;
							} else {
								breakLoop = true;
							}
						}
					})
					.catch((err) => {
						console.error(err.response);

						if (err.response.status === 400) {
							breakLoop = true;
							alert("Error in Code");
						}
					});

				// @ts-ignore
				if (breakLoop === true) {
					alert(`Failed at TestCase ${j + 1}`);
					break;
				}
			}

			for (let j = 0; j < pvt_testcase[1].length; j++) {
				let testcase = pvt_testcase[1][j];
				let encoded_code = "";
				if (data.hasScannerInputs) {
					encoded_code = Buffer.from(sol, "utf8").toString("base64");
				} else {
					encoded_code = Buffer.from(
						sol + testcase.code,
						"utf8"
					).toString("base64");
				}
				let breakLoop = false;
				await compilerAxios
					.post("/compile", {
						...compiler_data,
						code: encoded_code,
						input: data.hasScannerInputs
							? testcase.scannerInput?.replace("\r\n", "\n")
							: "",
						arguments: [],
					})
					// eslint-disable-next-line no-loop-func
					.then(({ data: result_data }) => {
						if (result_data.output !== null) {
							const code_output = Buffer.from(
								result_data.output,
								"base64"
							).toString("utf8");
							if (CheckTestCase(code_output, testcase.output)) {
								++compilerCount;
							} else {
								breakLoop = true;
							}
						}
					})
					.catch((err) => {
						console.error(err.response);

						if (err.response.status === 400) {
							breakLoop = true;
							alert("Error in Code");
						}
					});

				// @ts-ignore
				if (breakLoop === true) {
					alert(`Failed at Private TestCase ${j + 1}`);
					break;
				}
			}
		}

		isLoading(false);
		if (compilerCount === total_checks) {
			alert(`${lang} testcases passed`);
			setCheckedLangs((prev) => {
				if (prev.includes(lang)) {
					return prev;
				} else {
					let temp = [...prev, lang];
					return temp;
				}
			});
		} else {
			setCheckedLangs((prev) => {
				if (prev.includes(lang)) {
					let temp = prev.filter((val) => val !== lang);
					return temp;
				}
				return prev;
			});
		}
	}

	function copyTestCasesFromTo() {
		// return;
		if (testCaseType === "public") {
			let case_data: any;
			switch (cloneFromLang.value) {
				case "C++":
					case_data = JSON.parse(
						JSON.stringify(data_cpp)
					) as dataLanguage;
					break;
				case "C":
					case_data = JSON.parse(
						JSON.stringify(data_c)
					) as dataLanguage;
					break;
				case "Java":
					case_data = JSON.parse(
						JSON.stringify(data_java)
					) as dataLanguage;
					break;
				case "Python3":
					case_data = JSON.parse(
						JSON.stringify(data_python)
					) as dataLanguage;
					break;
				default:
					break;
			}
			cloneToLang.forEach((each) => {
				const l = JSON.stringify(case_data);
				if (each.value === "C++") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "c++";
					setData_cpp(m);
				} else if (each.value === "Java") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "java";
					setData_java(m);
				} else if (each.value === "Python3") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "python3";
					setData_python(m);
				} else if (each.value === "C") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "c";
					setData_c(m);
				}
			});

			if (case_data) {
				// alert(`Cloned Successfully ${testCaseType} !!!`);
			}
		} else if (testCaseType === "private") {
			let case_data: any;
			switch (cloneFromLang.value) {
				case "C++":
					case_data = data_cpp_pvt;
					break;
				case "C":
					case_data = data_c_pvt;
					break;
				case "Java":
					case_data = data_java_pvt;
					break;
				case "Python3":
					case_data = data_python_pvt;
					break;
				default:
					break;
			}
			cloneToLang.forEach((each) => {
				// dataLanguage_pvt
				console.log(each);
				const l = JSON.stringify(case_data);
				if (each.value === "C++") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "c++";
					setData_cpp_pvt(m);
				}
				if (each.value === "Java") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "java";
					setData_java_pvt(m);
				}
				if (each.value === "Python3") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "python3";
					setData_python_pvt(m);
				}

				if (each.value === "C") {
					const m: dataLanguage_pvt = JSON.parse(l);
					m[0].language = "c";
					setData_c_pvt(m);
				}
			});

			if (case_data) {
				// alert(`Cloned Successfully ${testCaseType} !!!`);
			}
		}

		console.log(data);
	}
	return (
		<div className="m-4">
			<Button
				className="my-4 px-3 py-1 rounded hover:bg-green-700"
				style={{
					backgroundColor: "blue",
					color: "#fff",
				}}
				onClick={submitHandler}
				disabled={isSubmit}
			>
				Submit Test Cases
			</Button>
			<Button
				className="my-4 mx-4 px-3 py-1 rounded hover:bg-green-700"
				style={{
					backgroundColor: "blue",
					color: "#fff",
				}}
				onClick={handleChecks}
				disabled={loading}
			>
				{loading ? "Running testcases..." : "Run all test"}
			</Button>

			<ToggleButtonGroup
				value={testCaseType}
				onChange={handleTestCaseTypeChange}
				exclusive
				color="primary"
			>
				<ToggleButton value="public">Public Test Cases</ToggleButton>
				<ToggleButton value="private">Private Test Cases</ToggleButton>
			</ToggleButtonGroup>
			<div className="flex flex-row gap-4 items-end bg-green-100 p-4 rounded-md">
				<div>
					<label className="mb-1 block text-black">
						Clone From Language.
					</label>
					<Select
						options={data.languages.map((each) => {
							return { value: each, label: each };
						})}
						components={animatecomponent}
						placeholder="Clone From..."
						value={cloneFromLang}
						isMulti={false}
						onChange={(values: any) => {
							setCloneFromLang(values);
							console.log(cloneFromLang);
						}}
						className="outline-none rounded-md border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200"
					/>
				</div>
				<div>
					<label className="mb-1 block text-black">
						Clone to Languages.
					</label>
					<Select
						options={data.languages.map((each) => {
							return { value: each, label: each };
						})}
						closeMenuOnSelect={false}
						placeholder="Clone To..."
						components={animatecomponent}
						value={cloneToLang}
						isMulti={true}
						onChange={(values: any) => {
							setCloneToLang(values);
							console.log(cloneToLang);
						}}
						className="outline-none rounded-md border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200"
					/>
				</div>
				<div>
					<label className="mb-1 block text-black">&nbsp;</label>
					<button
						onClick={() => {
							copyTestCasesFromTo();
						}}
						className="bg-blue-500 flex flex-row gap-2 text-black p-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
					>
						<CopySvg /> Clone Cases {testCaseType}
					</button>
				</div>
			</div>
			<Tabs
				defaultActiveKey={data.languages[0]}
				id="testcase-tab"
				className="mb-3"
				onSelect={(e) => {
					if (
						e === "C" ||
						e === "Java" ||
						e === "Python3" ||
						e === "C++"
					) {
						setLanguageTab(e);
					}
				}}
				activeKey={languageTab}
			>
				{data.languages.map((lang: language_options, index) => {
					return (
						<Tab
							eventKey={lang}
							title={
								<div>
									{lang}
									{checkedLangs.includes(lang) && (
										<i
											className="fas fa-check-circle"
											style={{ color: "#40f000" }}
										></i>
									)}
								</div>
							}
							style={{ marginBottom: "20px" }}
							key={index}
						>
							<TestCaseEditor
								language={getEditorLang(lang)}
								data={getEditorVariable(lang)}
								onEditorChange={onEditorChange}
								addTestCase={addTestCase}
								testCasePop={testCasePop}
								type={testCaseType}
								scannerInput={data.hasScannerInputs}
							/>
							<br />
						</Tab>
					);
				})}
			</Tabs>

			<button
				className="my-2 px-3 py-1 rounded hover:bg-green-700"
				style={{
					backgroundColor: "blue",
					color: "#fff",
				}}
				onClick={() => {
					let testcases: Array<
						[
							{
								language: language_options_l;
							},
							Array<{
								scannerInput?: string;
								code?: string;
								name: string;
								output: string;
							}>
						]
					> = [];
					let testcases_pvt: Array<
						[
							{
								language: language_options_l;
							},
							Array<{
								scannerInput?: string;
								code?: string;
								name: string;
								output: string;
								marks: number;
							}>
						]
					> = [];
					data.languages.forEach((val) => {
						if (val === "C") {
							testcases.push(data_c);
							testcases_pvt.push(data_c_pvt);
						} else if (val === "C++") {
							testcases.push(data_cpp);
							testcases_pvt.push(data_cpp_pvt);
						} else if (val === "Python3") {
							testcases.push(data_python);
							testcases_pvt.push(data_python_pvt);
						} else {
							testcases.push(data_java);
							testcases_pvt.push(data_java_pvt);
						}
					});
					prev({
						...data,
						testcases,
						privateTestcases: testcases_pvt,
					});
				}}
			>
				Prev
			</button>
		</div>
	);
}
const CopySvg = () => {
	return (
		<>
			<svg
				width="20px"
				height="20px"
				viewBox="0 0 24.00 24.00"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				stroke="#000000"
				stroke-width="0.00024000000000000003"
			>
				<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					stroke-linecap="round"
					stroke-linejoin="round"
				></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<path
						d="M14 16.75H6C5.27065 16.75 4.57118 16.4603 4.05546 15.9445C3.53973 15.4288 3.25 14.7293 3.25 14V6C3.25 5.27065 3.53973 4.57118 4.05546 4.05546C4.57118 3.53973 5.27065 3.25 6 3.25H14C14.7293 3.25 15.4288 3.53973 15.9445 4.05546C16.4603 4.57118 16.75 5.27065 16.75 6V14C16.75 14.7293 16.4603 15.4288 15.9445 15.9445C15.4288 16.4603 14.7293 16.75 14 16.75ZM6 4.75C5.66848 4.75 5.35054 4.8817 5.11612 5.11612C4.8817 5.35054 4.75 5.66848 4.75 6V14C4.75 14.3315 4.8817 14.6495 5.11612 14.8839C5.35054 15.1183 5.66848 15.25 6 15.25H14C14.3315 15.25 14.6495 15.1183 14.8839 14.8839C15.1183 14.6495 15.25 14.3315 15.25 14V6C15.25 5.66848 15.1183 5.35054 14.8839 5.11612C14.6495 4.8817 14.3315 4.75 14 4.75H6Z"
						fill="#000000"
					></path>{" "}
					<path
						d="M18 20.75H10C9.27065 20.75 8.57118 20.4603 8.05546 19.9445C7.53973 19.4288 7.25 18.7293 7.25 18V16H8.75V18C8.75 18.3315 8.8817 18.6495 9.11612 18.8839C9.35054 19.1183 9.66848 19.25 10 19.25H18C18.3315 19.25 18.6495 19.1183 18.8839 18.8839C19.1183 18.6495 19.25 18.3315 19.25 18V10C19.25 9.66848 19.1183 9.35054 18.8839 9.11612C18.6495 8.8817 18.3315 8.75 18 8.75H16V7.25H18C18.7293 7.25 19.4288 7.53973 19.9445 8.05546C20.4603 8.57118 20.75 9.27065 20.75 10V18C20.75 18.7293 20.4603 19.4288 19.9445 19.9445C19.4288 20.4603 18.7293 20.75 18 20.75Z"
						fill="#000000"
					></path>{" "}
				</g>
			</svg>
		</>
	);
};
